import { styled } from "styled-components";

const Flow = styled.div`
  > * + * {
    margin-top: var(--space-${props => props.$space});
  }
`;

export default Flow;